import { render } from "./LtBrand.vue?vue&type=template&id=2879f026"
import script from "./LtBrand.vue?vue&type=script&lang=js"
export * from "./LtBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__